/*
 * This illustrates how to modify the LoadOrdersHandler in a number of different ways.
 * The LoadOrdersHandler is used by the order history page to load order data
 */

import {
  
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import {
 
    watchForOtherTabSessionChange,
} from "@insite/client-framework/Services/SessionService";
import { chain, RedirectToChangeCustomer } from "@insite/client-framework/Store/Context/Handlers/SignIn";
import { getHomePageUrl, getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";

// this will enable HMR for custom handlers
if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(data => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}

// trying to reference a handler not in the chain will result in a warning and the chain will not be modified
replaceInChain(
    chain,
    RedirectToChangeCustomer,
    props =>
    {
        if (!props.authenticatedSession?.redirectToChangeCustomerPageOnSignIn) {
            watchForOtherTabSessionChange(); // This sign-in failed, but another tab might be successful later on.
            return;
        }

        const homePageUrl = getPageLinkByPageType(props.getState(), "HomePage")?.url;
        const dashboardPageUrl = getPageLinkByPageType(props.getState(), "MyAccountPage")?.url;
        // const changeCustomerPageUrl = getPageLinkByPageType(props.getState(), "ChangeCustomerPage")?.url;
        if (homePageUrl)
        {
            
            const shouldAddReturnUrl = props.parameter.returnUrl && props.parameter.returnUrl !== homePageUrl;
            const returnUrl = shouldAddReturnUrl
                ? props.parameter.returnUrl
                : props.authenticatedSession.dashboardIsHomepage
                ? dashboardPageUrl!
                : undefined;
    
            window.location.href = returnUrl || "";
            return false;
        }
    },
);
